// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","formFieldArea":"_2vx5BKuBEWD61qKNarkBtb","suggestionCardArea":"_1Hyk6tnMDSu5q2lAQdxStH","fieldHeader":"_1UgNYEg5c11yBXLfL7OwaW"};